<template>
  <card-container :blank="blank">
    <div :class="$style.loading" v-if="loading">
      <icon icon="innovatie" /> Loading...
    </div>

    <div v-if="!loading" v-html="mediaItem.htmlContent"></div>
  </card-container>
</template>

<script>
import {Api, Utils} from "@bvm/core";
import { CardContainer, Icon } from "@bvm/forms";

const i18nBuilder = new Utils.I18n.I18nBuilder("register_single_vehicle_form")
        .add("media_item_retrieval_failure");

export const messageKeys = i18nBuilder.getKeys();

export default {
  name: "media-item-card",
  props: {
    itemTag: { type: String, required: true },
    blank: { type: Boolean }
  },
  components: {
    CardContainer,
    Icon
  },
  data() {
    return {
      i18n: i18nBuilder.getData(),
      loading: true,
      mediaItem: {}
    };
  },
  mounted() {
    Api.MediaItem.getMediaItem('bvmop basic clean display on', "article", true, this.itemTag).then(mediaItem => {
      this.mediaItem = mediaItem;
      this.loading = false;
    }).catch(() => {
      Bovemij.notifyFailure('',this.$t(this.i18n.media_item_retrieval_failure));
      this.loading = false;
    });
  }
};
</script>

<style module lang="scss">
.loading {
  text-align: center;

  span {
    display: inline-block;
  }
}
</style>
